// @flow
import React from 'react';
import PropTypes from 'prop-types';

type Props = {
  delegate: Object,
  selectedCompany: Object,
  isOpenModal: boolean,
};

class SMUBusinessAccountRemoveView extends React.Component {

  constructor(props: Props) {
    super(props);

    this.state = {
      isOpenModal: this.props.isOpenModal
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      isOpenModal: nextProps.isOpenModal
    });
  }

  handleModalChange(e: Object){
    e.preventDefault();

    if(this.props.delegate && (typeof this.props.delegate.handleModalChange == 'function')) {
      return this.props.delegate.handleModalChange({}, e);
    }
  }

  handleRemoveClick(e: Object){
    e.preventDefault();

    if(this.props.delegate && (typeof this.props.delegate.handleRemoveClick == 'function')) {
      return this.props.delegate.handleRemoveClick(e);
    }
  }

  render() {
    if (!this.state.isOpenModal) return null;

    return(
      <div className="form-casette maincol-lightbox__form maincol-lightbox__form-s">
        <div className="form-box ta-c pb5">
          <div className="mb30">
            <h2 className="dashboard-title mb10">ビジネスアカウントの解除</h2>
            <p className="dashboard-title__supplement">{this.props.selectedCompany.name}からアカウントを解除します。<br />よろしいですか？</p>
          </div>
          <input onClick={this.handleModalChange.bind(this)} className="button-gray pt10 pb10 w200 mr5" type="submit" defaultValue="キャンセル" />
          <input onClick={this.handleRemoveClick.bind(this)} className="button-green pt10 pb10 w200 ml5" type="submit" defaultValue="解除する" />
        </div>
        <a onClick={this.handleModalChange.bind(this)} className="form-casette__close"><i className="fa fa-times" /></a>
      </div>
    );
  }
}
export default SMUBusinessAccountRemoveView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/fragments/SMUBusinessAccountRemoveView.jsx